export const SEO_DEFAULTS = {
  siteName: "PDN & Associates",
  defaultTitle: "PDN & Associates | Chartered Accountants in Bangalore",
  defaultDescription:
    "PDN & Associates is a Chartered Accountants firm in Bangalore offering GST, Income Tax, company registration, audits, compliance and advisory. Call +91 9606078040.",
  defaultKeywords:
    "PDN & Associates, chartered accountants Bangalore, CA firm Bangalore, GST registration, GST returns, income tax filing, tax audit, company registration, LLP registration, compliance, advisory",
  phoneE164: "+919606078040",
  address: {
    streetAddress: "402, Paras Pearl, Green Glen Layout, Bellandur",
    addressLocality: "Bangalore",
    addressRegion: "Karnataka",
    postalCode: "560103",
    addressCountry: "IN",
  },
  email: "INFO@PDNANDASSOCIATES.COM",
  ogImagePath: "/Logo.png",
  locale: "en_IN",
};

const ROUTE_SEO = {
  "/": {
    title: "PDN & Associates | Chartered Accountants in Bangalore",
    description:
      "PDN & Associates is a Chartered Accountants firm in Bangalore offering GST, Income Tax, company registration, audits, compliance and advisory. Call +91 9606078040.",
    keywords:
      "chartered accountants Bangalore, CA firm Bangalore, GST registration Bangalore, GST returns filing, income tax filing, tax audit, company registration, compliance",
  },
  "/aboutus": {
    title: "About Us",
    description:
      "Learn about PDN & Associates, a Chartered Accountants firm in Bangalore. Expertise across GST, Income Tax, audits, compliance, and business advisory.",
    keywords:
      "about PDN & Associates, chartered accountants Bangalore, CA firm Bangalore, audit and compliance",
  },
  "/ourteam": {
    title: "Our Team",
    description:
      "Meet the team at PDN & Associates. Chartered Accountants and professionals supporting your GST, tax, audit, and compliance needs.",
    keywords:
      "PDN & Associates team, chartered accountants Bangalore, CA professionals",
  },
  "/contact": {
    title: "Contact Us",
    description:
      "Contact PDN & Associates in Bangalore for GST, Income Tax, audit and compliance support. Call +91 9606078040 or email INFO@PDNANDASSOCIATES.COM.",
    keywords:
      "contact PDN & Associates, chartered accountants Bangalore contact, CA Bangalore phone, +91 9606078040",
  },
  "/partnership": {
    title: "Partnership Firm Registration",
    description:
      "Get help with partnership firm registration and compliance. PDN & Associates provides guidance on documentation, registration, and ongoing filings.",
    keywords:
      "partnership firm registration, partnership deed, firm registration Bangalore, CA services",
  },
  "/OnePersonCompany": {
    title: "One Person Company (OPC) Registration",
    description:
      "OPC registration support with documentation and compliance. PDN & Associates helps you register and stay compliant with ROC requirements.",
    keywords:
      "OPC registration, one person company registration, company registration Bangalore, ROC compliance",
  },
  "/limitedLiabilityPartnership": {
    title: "LLP Registration",
    description:
      "Limited Liability Partnership (LLP) registration and compliance support. PDN & Associates helps with incorporation and annual filings.",
    keywords:
      "LLP registration, limited liability partnership, LLP compliance, LLP annual filing",
  },
  "/privatelimitedcompany": {
    title: "Private Limited Company Registration",
    description:
      "Private limited company registration and ROC compliance support. PDN & Associates assists with incorporation, documentation and ongoing filings.",
    keywords:
      "private limited company registration, pvt ltd incorporation, ROC filings, company compliance",
  },
  "/trustregistration": {
    title: "Trust Registration",
    description:
      "Trust registration assistance including documentation and compliance guidance. PDN & Associates supports charitable and private trust registrations.",
    keywords:
      "trust registration, charitable trust registration, trust deed, CA Bangalore",
  },
  "/societyregistration": {
    title: "Society Registration",
    description:
      "Society registration support with documentation and compliance. PDN & Associates helps you complete the registration process smoothly.",
    keywords:
      "society registration, society registration Bangalore, NGO registration, compliance",
  },
  "/gstregistration": {
    title: "GST Registration",
    description:
      "GST registration support with end-to-end assistance. PDN & Associates helps with eligibility, documentation and application filing.",
    keywords:
      "GST registration, GST registration Bangalore, GSTIN, GST consultant",
  },
  "/gstreturns": {
    title: "GST Returns Filing",
    description:
      "GST returns filing and compliance support. PDN & Associates helps you prepare and file returns accurately and on time.",
    keywords:
      "GST returns filing, GSTR-1, GSTR-3B, GST compliance, GST consultant Bangalore",
  },
  "/gstannualreturn": {
    title: "GST Annual Return",
    description:
      "GST annual return preparation and filing. PDN & Associates assists with reconciliation, reporting and timely annual compliance.",
    keywords:
      "GST annual return, GSTR-9, GSTR-9C, GST reconciliation, annual compliance",
  },
  "/gstewaybill": {
    title: "GST E-Way Bill",
    description:
      "E-way bill guidance and compliance support. PDN & Associates helps you understand requirements and avoid penalties.",
    keywords:
      "e-way bill, GST eway bill, eway bill compliance, GST consultant",
  },
  "/gstadvisoryandcompliance": {
    title: "GST Advisory & Compliance",
    description:
      "GST advisory and ongoing compliance support. PDN & Associates helps businesses manage GST obligations confidently.",
    keywords:
      "GST advisory, GST compliance, GST consultant Bangalore, GST planning",
  },
  "/gstlitigationservices": {
    title: "GST Litigation Services",
    description:
      "GST litigation and dispute support. PDN & Associates assists with notices, responses and representation for GST matters.",
    keywords:
      "GST litigation, GST notice reply, GST disputes, GST representation",
  },
  "/annualcomplianceprivatelimited": {
    title: "Annual Compliance (Private Limited)",
    description:
      "Annual ROC compliance support for private limited companies. PDN & Associates helps you meet filing requirements on time.",
    keywords:
      "annual compliance private limited, ROC annual filing, company compliance, MCA filings",
  },
  "/annualcompliancellp": {
    title: "Annual Compliance (LLP)",
    description:
      "Annual compliance support for LLPs including return filings and documentation. PDN & Associates helps you stay compliant.",
    keywords:
      "LLP annual compliance, LLP filings, Form 8, Form 11, LLP compliance",
  },
  "/proprietorshipregistration": {
    title: "Proprietorship Registration",
    description:
      "Proprietorship registration guidance and compliance support. PDN & Associates helps with registrations and business setup needs.",
    keywords:
      "proprietorship registration, sole proprietorship, business registration, CA Bangalore",
  },
  "/taxauditoverview": {
    title: "Tax Audit",
    description:
      "Tax audit support and guidance. PDN & Associates helps with audit requirements, documentation and reporting.",
    keywords:
      "tax audit, income tax audit, audit report, chartered accountant audit services",
  },
  "/certificationservices": {
    title: "Certification Services",
    description:
      "Certification services by Chartered Accountants including certificates for banking, compliance and statutory requirements.",
    keywords:
      "CA certification services, certificates by chartered accountant, statutory certificates",
  },
  "/shopandestablishmentactIndia": {
    title: "Shop & Establishment Registration",
    description:
      "Shop and Establishment registration support. PDN & Associates helps businesses complete required registrations and compliance.",
    keywords:
      "shop and establishment registration, labour registration, business compliance",
  },
  "/udyogaadharregistration": {
    title: "Udyog Aadhaar / Udyam Registration",
    description:
      "Udyog Aadhaar (Udyam) registration assistance for MSMEs. PDN & Associates helps you complete registration and documentation.",
    keywords:
      "udyam registration, udyog aadhaar, MSME registration, small business registration",
  },
  "/fssaigegistrationlicense": {
    title: "FSSAI Registration & License",
    description:
      "FSSAI registration and license support. PDN & Associates helps food businesses obtain registrations and stay compliant.",
    keywords:
      "FSSAI registration, FSSAI license, food business compliance, registration support",
  },
  "/trademarkregistrationindia": {
    title: "Trademark Registration",
    description:
      "Trademark registration guidance and support. PDN & Associates helps with application, documentation and process overview.",
    keywords:
      "trademark registration, brand protection, trademark application, trademark consultant",
  },
  "/importerexportercodeindia": {
    title: "Importer Exporter Code (IEC)",
    description:
      "IEC (Importer Exporter Code) registration support. PDN & Associates helps you obtain IEC for import/export operations.",
    keywords:
      "IEC registration, importer exporter code, DGFT IEC, import export license",
  },
  "/isocertificationindia": {
    title: "ISO Certification",
    description:
      "ISO certification guidance and support. PDN & Associates helps you understand requirements and documentation for certification.",
    keywords:
      "ISO certification, ISO registration, ISO documentation, business certification",
  },
  "/reraregistrationindia": {
    title: "RERA Registration",
    description:
      "RERA registration and compliance guidance. PDN & Associates supports documentation and process understanding for RERA needs.",
    keywords:
      "RERA registration, real estate regulatory, builder registration, RERA compliance",
  },
  "/tradelicenseindia": {
    title: "Trade License",
    description:
      "Trade license guidance and registration support. PDN & Associates helps businesses obtain trade licenses and stay compliant.",
    keywords:
      "trade license, trade license registration, municipal trade license, business license",
  },
  "/professionaltaxindia": {
    title: "Professional Tax Registration",
    description:
      "Professional tax registration and compliance support. PDN & Associates helps with registration, returns and timely payments.",
    keywords:
      "professional tax registration, PT registration, professional tax compliance, returns filing",
  },
};

export function getSeoForPath(pathname) {
  const routeSeo = ROUTE_SEO[pathname] || {};
  return {
    title: routeSeo.title || SEO_DEFAULTS.defaultTitle,
    description: routeSeo.description || SEO_DEFAULTS.defaultDescription,
    keywords: routeSeo.keywords || SEO_DEFAULTS.defaultKeywords,
  };
}

